import '../css/main.scss'
import components from './components'

components.forEach((Component) => new Component())
